import React from "react";
import logo from "./logo.png";

const active = {
  background: "#f9db19",
  borderColor: "#f9db19",
  color: "rgb(0, 152, 229)",
};

const Menu = ({ onClick, selected }) => (
  <ul className="list-unstyled">
    <li className="px-2" onClick={() => onClick("intro")}
        style={{cursor:'pointer'}}>
      <img src={logo} alt="logo" width="120" />
    </li>
    <li
      className="m-0 px-4 py-1 btn btn-block btn-primary rounded-0 text-left"
      onClick={() => onClick("intro")}
      style={selected === "intro" ? active : {}}
    >
      <h4 className="mb-1">Welcome</h4>
    </li>
    <li
      className="m-0 px-4 py-1 btn btn-block btn-primary rounded-0 text-left"
      style={selected === "auth" ? active : {}}
      onClick={() => onClick("auth")}
    >
      <h4 className="mb-1">Authentication</h4>
    </li>
    <li
      className="m-0 px-4 py-1 btn btn-block btn-primary rounded-0 text-left"
      style={selected === "users" ? active : {}}
      onClick={() => onClick("users")}
    >
      <h4 className="mb-1">Users</h4>
    </li>
    <li
      className="m-0 px-4 py-1 btn btn-block btn-primary rounded-0 text-left"
      style={selected === "groups" ? active : {}}
      onClick={() => onClick("groups")}
    >
      <h4 className="mb-1">Groups</h4>
    </li>
    <li
      className="m-0 px-4 py-1 btn btn-block btn-primary rounded-0 text-left"
      style={selected === "contacts" ? active : {}}
      onClick={() => onClick("contacts")}
    >
      <h4 className="mb-1">Contacts</h4>
    </li>
    <li
      className="m-0 px-4 py-1 btn btn-block btn-primary rounded-0 text-left"
      style={selected === "events" ? active : {}}
      onClick={() => onClick("events")}
    >
      <h4 className="mb-1">Calendar</h4>
    </li>
    <li
      className="m-0 px-4 py-1 btn btn-block btn-primary rounded-0 text-left"
      style={selected === "fax" ? active : {}}
      onClick={() => onClick("fax")}
    >
      <h4 className="mb-1">Fax</h4>
    </li>
    <li
      className="m-0 px-4 py-1 btn btn-block btn-primary rounded-0 text-left"
      style={selected === "mailoffice" ? active : {}}
      onClick={() => onClick("mailoffice")}
    >
      <h4 className="mb-1">Mail office</h4>
    </li>
    <li
      className="m-0 px-4 py-1 btn btn-block btn-primary rounded-0 text-left"
      style={selected === "punchings" ? active : {}}
      onClick={() => onClick("punchings")}
    >
      <h4 className="mb-1">Puncher</h4>
    </li>
    <li
      className="m-0 px-4 py-1 btn btn-block btn-primary rounded-0 text-left"
      style={selected === "tickets" ? active : {}}
      onClick={() => onClick("tickets")}
    >
      <h4 className="mb-1">Tickets</h4>
    </li>
    <li
      className="m-0 px-4 py-1 btn btn-block btn-primary rounded-0 text-left"
      style={selected === "wiki" ? active : {}}
      onClick={() => onClick("wiki")}
    >
      <h4 className="mb-1">Wiki</h4>
    </li>
  </ul>
);
export default Menu;
